import React, { useState, useEffect } from 'react'
import { Avatar } from 'antd'
import { UserOutlined } from '@ant-design/icons';

import { 
  useAvatar,
  useGame
} from 'data/hooks'

const PodiumPosition = props => {
  
  const { gameId, player, className, badgetwo, pointsTitle, formatValue } = props
  const { userId, userName, value, position } = player || {}
  const { avatar } = useAvatar(gameId, userId)

  return (
    <div className={`avatar-name ${className}`}>
      <div 
        className={`
          avatar
          ${ player.userData.groupId }
        `}
      >
        <Avatar src={avatar}
                icon={<UserOutlined />}
                size={position === 1 ? 100 : 80} />
      </div>
      <div className="badge">
        <img src={badgetwo} />
      </div>
      <div className="position">
        <div className="value">{position}</div>
      </div>
      <div className="name-points">
        <div className="name">
          {userName}
        </div>
        <div className="points">
          {formatValue(value)} {pointsTitle}
        </div>
      </div>
    </div>
  )
}

export const Podium = props => {

  const { gameId, list, formatValue } = props

  return (<>
    <div className="podium">
      { list.length > 1 && <PodiumPosition  className="second" 
                                            gameId={gameId}
                                            pointsTitle=""
                                            player={list[1]} 
                                            formatValue={formatValue} /> }
      { list.length > 0 && <PodiumPosition  className="first" 
                                            gameId={gameId}
                                            pointsTitle=""
                                            player={list[0]} 
                                            formatValue={formatValue} /> }
      { list.length > 2 && <PodiumPosition  className="third" 
                                            gameId={gameId}
                                            pointsTitle=""
                                            player={list[2]} 
                                            formatValue={formatValue} /> }
    </div>
  </>)
}
